import { render, staticRenderFns } from "./malfunctions.vue?vue&type=template&id=aefc65d6&scoped=true"
import script from "./malfunctions.vue?vue&type=script&lang=js"
export * from "./malfunctions.vue?vue&type=script&lang=js"
import style0 from "./malfunctions.vue?vue&type=style&index=0&id=aefc65d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefc65d6",
  null
  
)

export default component.exports